import { css } from "@emotion/core";

import { commonFoldStyles } from "../EligibilityViewStyles";

export { commonFoldStyles as CompanyDetailsFoldStyles };

export const radioCapitalizeStyle = css({
  ".ant-radio-wrapper > span": {
    textTransform: "capitalize"
  }
});
